import React from 'react'

export default function fetchData (fetch) {

  return (DecoratedComponent) => {
    return class FetchData extends React.Component {

      componentDidMount () {
        fetch(this.props, this.props)
      }

      componentWillUpdate(nextProps, nextState) {
        fetch(this.props, nextProps)
      }

      render () {
        return (
          <DecoratedComponent {...this.props} />
        )
      }
    }
  }

}


// WEBPACK FOOTER //
// ./src/decorators/fetchData.js